<template>
  <div class="v-modal">
    <div class="v-modal__header">
      <span>River Basin Selection</span>
      <div @click="cancel()" class="close"></div>
    </div>
    <div class="v-modal__body">
      <Errors @dismiss="errors = []" :errors="errors"/>
      <multiselect
        ref="vms"
        v-model="value"
        :options="basins"
        :multiple="true"
        :close-on-select="false"
        :show-labels="false"
        placeholder="Search river basin"
        label="name"
        track-by="basinID"
      ></multiselect>
    </div>
    <div class="v-modal__footer">
      <button @click="next()" class="btn btn-primary">Next</button>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Errors from "@/components/shared/Errors.vue";
import { assessment } from "@/services/assessment-model.js";
import { basins } from "@/services/entity-model.js";
import { closeModal } from "@/services/modal-model";

export default {
  name: "RiverBasin",
  components: {
    Multiselect,
    Errors
  },
  props: {
    modal: {type: Object}
  },
  data() {
    return {
      value: [],
      basins,
      errors: []
    };
  },
  watch: {
    value() {
      this.errors = [];
    }
  },
  mounted() {
    this.$refs.vms.$el.focus();
  },
  methods: {
    cancel() {
      this.close();
      assessment.setAssessmentType(null);
    },
    next() {
      this.validate();
      if (this.errors.length == 0) {
        this.close();
        assessment.setCountriesOrBasins(this.value);
        assessment.nextStep();
      }
    },
    close() {
      closeModal(this.modal);
    },
    validate() {
      this.errors = [];
      if (this.value.length == 0) {
        this.errors.push("No river basin selected.");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-modal__body {
  height: 345px;
}
</style>
